import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api/axios";
import "./CompanyDetailPage.scss";

export default function CompanyDetailPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [company, setCompany] = useState(null);
    const [loading, setLoading] = useState(true);
    const [playlists, setPlaylists] = useState([]);
    const [form, setForm] = useState({
        activePlaylistId: "",
        comment: "",
        deviceCodes: "",
        isInactiveNotificationDisabled: false,
    });
    const [saving, setSaving] = useState(false);

    // Загрузка компании и плейлистов
    useEffect(() => {
        setLoading(true);
        Promise.all([
            api.get(`/admin/companies/${id}`),
            api.get("/getPlayListAll"),
        ]).then(([companyResp, playlistsResp]) => {
            setCompany(companyResp.data);
            setPlaylists(playlistsResp.data);
            setForm({
                activePlaylistId: companyResp.data.activePlaylistId || "",
                comment: companyResp.data.comment || "",
                deviceCodes: (companyResp.data.deviceCodes || []).join(", "),
                isInactiveNotificationDisabled: Boolean(companyResp.data.isInactiveNotificationDisabled),
            });
        }).finally(() => setLoading(false));
    }, [id]);

    // Обработка изменений в форме
    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;
        setForm(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
    };

    // Сохранение
    const handleSave = (e) => {
        e.preventDefault();
        setSaving(true);
        api.put(`/admin/companies/${id}`, {
            activePlaylistId: form.activePlaylistId || null,
            comment: form.comment,
            isInactiveNotificationDisabled: form.isInactiveNotificationDisabled,
            deviceCodes: form.deviceCodes
                .split(",")
                .map(code => code.trim())
                .filter(Boolean),
        })
            .then(resp => {
                setCompany(resp.data);
            })
            .finally(() => setSaving(false));
    };

    if (loading) return <div className="company-detail-loading">Загрузка...</div>;
    if (!company) return <div>Компания не найдена</div>;

    return (
        <div className="company-detail-page">
            <button className="company-back-btn" onClick={() => navigate(-1)}>
                ← Назад к списку
            </button>
            <h2>Компания: {company.title}</h2>
            <div className="company-info">
                <div><b>ID:</b> {company.id}</div>
                <div><b>Страна:</b> {company.country || "-"}</div>
                <div><b>Регион:</b> {company.region || "-"}</div>
                <div><b>Город:</b> {company.city || "-"}</div>
                <div><b>Адрес:</b> {company.address || "-"}</div>
                <div><b>ИП:</b> {company.legalName || "-"}</div>
                <div><b>Менеджер:</b> {company.manager || "-"}</div>
                <div><b>Последняя активность:</b> {company.lastActive ? new Date(company.lastActive).toLocaleString() : "-"}</div>
                <div>
                    <b>Офлайн-уведомления:</b>{" "}
                    {company.isInactiveNotificationDisabled ? "отключены" : "включены"}
                </div>
            </div>

            <form className="company-detail-form" onSubmit={handleSave}>
                <div className="form-group">
                    <label>Активный плейлист:</label>
                    <select
                        name="activePlaylistId"
                        value={form.activePlaylistId}
                        onChange={handleChange}
                    >
                        <option value="">Не выбран</option>
                        {playlists.map(pl => (
                            <option key={pl.id} value={pl.id}>
                                {pl.title}
                            </option>
                        ))}
                    </select>
                </div>

                <label className="form-checkbox">
                    <input
                        type="checkbox"
                        name="isInactiveNotificationDisabled"
                        checked={form.isInactiveNotificationDisabled}
                        onChange={handleChange}
                    />
                    <span>Не уведомлять об офлайне</span>
                </label>

                <div className="form-group">
                    <label>Комментарий:</label>
                    <textarea
                        name="comment"
                        value={form.comment}
                        onChange={handleChange}
                        rows={3}
                        placeholder="Комментарий к компании"
                    />
                </div>

                <div className="form-group">
                    <label>Коды приставок (через запятую):</label>
                    <input
                        type="text"
                        name="deviceCodes"
                        value={form.deviceCodes}
                        onChange={handleChange}
                        placeholder="Пример: 123456, 789123"
                    />
                </div>

                <button
                    type="submit"
                    className="company-save-btn"
                    disabled={saving}
                >
                    {saving ? "Сохраняем..." : "Сохранить"}
                </button>
            </form>
        </div>
    );
}
